import { useMemo } from "react";
import type { LanguageCode } from "../api/contracts/language-settings";
import { useOptionalConfiguration } from "../contexts/ConfigurationProvider";

/** Offered by every site, and all a site offers before its config has loaded. */
export const MANDATORY_LANGUAGES: LanguageCode[] = ["sv-SE", "en-GB"];

/**
 * The languages this site lets a guest switch to.
 *
 * Read from the site configuration rather than passed down, because the
 * pickers live on screens that have no site of their own — the not-found page,
 * an expired payment link — where the mandatory pair is the honest answer.
 *
 * The set is the facility's "active in the WBE" one. A language being
 * translated is switched on in the PMS first and only reaches this list when
 * the operator says it is finished, so a guest is never handed a half-written
 * booking engine.
 */
export const useOfferedLanguages = (): LanguageCode[] => {
  const offered = useOptionalConfiguration()?.configuration?.languages;

  return useMemo(
    () => (offered?.length ? offered : MANDATORY_LANGUAGES),
    [offered],
  );
};
